module.exports = __webpack_public_path__ + "static/media/facebook-celebrity.46d7a03e.svg";